import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Box from "@mui/material/Box";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@material-ui/core/Paper";
import { Button, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import http from "../services/httpService";
import {
  prospectDetailsPath,
  landingpage2Path,
  getDateTime,
} from "../utils/varialbles";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import toast from "react-hot-toast";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  circle: {
    borderRadius: "100%",
    background: "#3f51b5",
    color: "#fff",
  },
});

const LandingPage2 = () => {
  const location = useLocation();
  let history = useHistory();
  const classes = useStyles();
  const [showWindow, setShowWindow] = useState(true);
  const [data, setData] = useState([]);

  const [columns, setColumns] = useState([
    {
      headerName: "Questions",
      id: "question",
      show: true,
      minWidth: 150,
      // type: "link",
    },
    {
      headerName: "Answers",
      id: "answer",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Date",
      id: "date",
      show: true,
      minWidth: 150,
      type: "date",
    },
  ]);

  const myparam = location.state;
  useEffect(() => {
    if (myparam && myparam.cust__id) {
      http
        .get("/landing_page_questions/" + myparam.cust__id)
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.Data &&
            Array.isArray(res.data.Data) &&
            res.data.Data.length > 0
          ) {
            setData(res.data.Data);
          } else {
            toast.error("Sorry, no question and answers found");
          }
        })
        .catch((err) => { });
    }
  }, []);

  // (data);

  const gotoProspectDetails = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: landingpage2Path,
        state: myparam,
      });
    }
  };

  return (
    <Box
      sx={{ height: 400, width: "100%" }}
      container
      style={showWindow ? { display: "block" } : { display: "none" }}
    >
      <Grid container style={{ marginTop: "10px", marginBottom: "15px" }}>
        <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoProspectDetails}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }}>
          <Typography color="textPrimary" variant="h5">
            Landing Page 2 - Responses
          </Typography>
        </Grid>
      </Grid>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.id} align={col.align}>
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((item) => {
              return (
                <TableRow>
                  {columns.map((cols) => {
                    const value = item[cols.id];
                    // (item);
                    return (
                      <TableCell>
                        {cols.type === "date"
                          ? getDateTime(value)
                          : value
                            ? value
                            : "N/A"}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        checkboxSelection
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
      /> */}
    </Box>
    // <div>LandingPage2</div>
  );
};

export default LandingPage2;
